import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-settlement-calendar-event',
  template: `
    <div class="card border-0 rounded-4 shadow settlement-event-card" 
         [ngClass]="{'d-none': !isVisible}" 
         [ngStyle]="cardStyle"
         *ngIf="selectedEvent">
      <div class="card-header bg-transparent border-0 d-flex align-items-center justify-content-between py-3">
        
        <button type="button" class="btn-close" (click)="hideCard()"></button>
      </div>
      <div class="card-body">
        <h6 class="m-0"><strong>{{ selectedEvent.title }}</strong></h6>
        <!-- p class="mb-2">
          <strong>Condominio:</strong> {{ selectedEvent.settlement?.name }}
        </p -->
        <p class="mb-2">
          <strong>Fecha:</strong> {{ selectedEvent.start | date: 'dd/MM/yyyy' }}
        </p>
        <p class="mb-0" *ngIf="selectedEvent.isStartCycle">
          <fa-icon [icon]="icons.faGauge" class="text-success me-2"></fa-icon> Inicio de ciclo de facturación
        </p>
        <p class="mb-0" *ngIf="!selectedEvent.isStartCycle">
          {{ selectedEvent.description }}
        </p>
      </div>
    </div>
  `,
  styles: [`
    .settlement-event-card {
      position: absolute;
      z-index: 1050;
      min-width: 300px;
      max-width: 350px;
    }
  `]
})
export class SettlementCalendarEventComponent {
  @Input() top: number = 0;
  @Input() left: number = 0;
  @Input() isVisible: boolean = false;
  @Input() selectedEvent: any = null;

  @Output() isVisibleChange = new EventEmitter<boolean>();

  cardStyle: any = {};

  constructor(public icons: IconsService) {}

  ngOnInit(): void {
    this.updateCardPosition();
  }

  ngOnChanges(): void {
    if (this.isVisible) {
      setTimeout(() => this.updateCardPosition(), 0);
    }
  }

  hideCard(): void {
    this.isVisible = false;
    this.isVisibleChange.emit(false);
  }

  updateCardPosition(): void {
    // Get window dimensions
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    
    // Calculate card dimensions (approximately)
    const cardHeight = 200; // approximate height
    const cardWidth = 320; // approximate width
    
    // Base position from the click
    let adjustedTop = this.top + 10;
    let adjustedLeft = this.left + 10;
    
    // Make sure the card doesn't go below the viewport
    if (adjustedTop + cardHeight > windowHeight) {
      adjustedTop = this.top - cardHeight - 10;
    }
    
    // Make sure the card doesn't go beyond the right edge
    if (adjustedLeft + cardWidth > windowWidth) {
      adjustedLeft = this.left - cardWidth - 10;
    }
    
    // Make sure the card doesn't go above the viewport
    if (adjustedTop < 0) {
      adjustedTop = 10;
    }
    
    // Make sure the card doesn't go beyond the left edge
    if (adjustedLeft < 0) {
      adjustedLeft = 10;
    }
    
    // Update style
    this.cardStyle = {
      top: `${adjustedTop}px`,
      left: `${adjustedLeft}px`
    };
  }
}
